import React from 'react'
import './App.css'

import { Routes, Route } from 'react-router-dom'

import NotFound from './pages/NotFound'
import Signin from './pages/Signin'
import Dashboard from './pages/Dashboard'

import ResturantList from './pages/Resturants/Lists'
import ResturantCreate from './pages/Resturants/Create'
import EditResturant from './pages/Resturants/Edit'

import CategoryList from './pages/Category/Lists'
import CategoryCreate from './pages/Category/Create'
import CategoryEdit from './pages/Category/Edit'

import FoodList from './pages/Foods/Lists'
import FoodCreate from './pages/Foods/Create'
import FoodEdit from './pages/Foods/Edit'

import Qrcode from './pages/Qrcode'

import Order from './pages/Order'
import OrderSelect from './pages/Order/Select'
import OrderAnalytics from './pages/Order/Analytics'
import Orders from './pages/Order/AllOrders'
import OrderItem from './pages/Order/Order'

import OffCode from './pages/OffCode/Lists'
import OffCodeCrate from './pages/OffCode/Create'
import OffCodeEdit from './pages/OffCode/Edit'

import Server from './pages/Server/Lists'
import CreateTable from './pages/Server/CreateTable'
import EditTable from './pages/Server/edit'

import Support from './pages/Support/List'
import SupportDetails from './pages/Support/Details'

import UserList from './pages/Users/Lists'
import UserDetail from './pages/Users/Details'

import Slider from './pages/Slider/Lists'
import SliderCreate from './pages/Slider/Create'
import SliderEdit from './pages/Slider/Edit'

import File from './pages/Files'

import Setting from './pages/Setting'

//Customet Club
import CustomerClub from './pages/CustomerClub/Dashboard'

import CCUserCreate from './pages/CustomerClub/Users/Create'
import CCUserList from './pages/CustomerClub/Users/Lists'
import CCUserDetail from './pages/CustomerClub/Users/Details'

import CCCommentsList from './pages/CustomerClub/Comments/Lists'
import CCCommentsDetail from './pages/CustomerClub/Comments/Details'

import CCCampaignsCreate from './pages/CustomerClub/Campaigns/Create'
import CCCampaignsList from './pages/CustomerClub/Campaigns/Lists'
import CCCampaignsDetail from './pages/CustomerClub/Campaigns/Details'

import CCOrder from './pages/CustomerClub/Orders'

import CCReport from './pages/CustomerClub/Reports'

import CCOffCodeCreate from './pages/CustomerClub/Offs/Create'
import CCOffCodeList from './pages/CustomerClub/Offs/Lists'
import CCOffCodeDetail from './pages/CustomerClub/Offs/Details'

import CCCashBack from './pages/CustomerClub/Cashback'

import CCSendSms from './pages/CustomerClub/Sms'

//Internal Menu
import InternalMenu from './pages/InternalMenu/Dashboard'

import IMResturantList from './pages/InternalMenu/Resturants/Lists'
import IMResturantCreate from './pages/InternalMenu/Resturants/Create'
import IMEditResturant from './pages/InternalMenu/Resturants/Edit'

import IMCategoryList from './pages/InternalMenu/Category/Lists'
import IMCategoryCreate from './pages/InternalMenu/Category/Create'
import IMCategoryEdit from './pages/InternalMenu/Category/Edit'

import IMFoodList from './pages/InternalMenu/Foods/Lists'
import IMFoodCreate from './pages/InternalMenu/Foods/Create'
import IMFoodEdit from './pages/InternalMenu/Foods/Edit'

import IMQrcode from './pages/InternalMenu/Qrcode'

import IMFiles from './pages/InternalMenu/ImFiles'

import IMServer from './pages/InternalMenu/Server/Lists'
import IMCreateTable from './pages/InternalMenu/Server/CreateTable'
import IMEditTable from './pages/InternalMenu/Server/edit'

import IMFaq from './pages/InternalMenu/Faq/Lists'
import IMFaqCreate from './pages/InternalMenu/Faq/Create'
import IMFaqEdit from './pages/InternalMenu/Faq/Edit'

import IMJobs from './pages/InternalMenu/Job/Lists'
import IMJobsDetails from './pages/InternalMenu/Job/Details'

import IMReservation from './pages/InternalMenu/Reservation/Lists'
import IMReservationDetails from './pages/InternalMenu/Reservation/Detail'

import IMSlider from './pages/InternalMenu/Slider/Lists'
import IMSliderCreate from './pages/InternalMenu/Slider/Create'
import IMSliderEdit from './pages/InternalMenu/Slider/Edit'

import IMBanner from './pages/InternalMenu/Banners/Lists'
import IMBannerCreate from './pages/InternalMenu/Banners/Create'
import IMBannerEdit from './pages/InternalMenu/Banners/Edit'

import PeykDashbord from './pages/Peyk/Dashboard'

import PeyksList from './pages/Peyk/Peyks/Lists'
import PeykCreate from './pages/Peyk/Peyks/Create'
import PeykEdit from './pages/Peyk/Peyks/Edit'

import PeykOrderList from './pages/Peyk/Orders/Lists'
import PeykOrderDetail from './pages/Peyk/Orders/Details'

import PeykAccounting from './pages/Peyk/Accounting'

import PeykMonitoring from './pages/Peyk/Monitoring'

import PeykMessageList from './pages/Peyk/Message/Lists'
import PeykMessageSend from './pages/Peyk/Message/Send'
import PeykMessageDetail from './pages/Peyk/Message/Details'

import PeykJobList from './pages/Peyk/Job/Lists'
import PeykJobDetail from './pages/Peyk/Job/Details'

import Layout from './components/Layout'

function App() {
  return (
    <div className='App'>
      <Routes>
        <Route path='*' element={<NotFound />} />
        <Route path='/' exact index element={<Signin />} />

        <Route element={<Layout />}>
          <Route path='/dashboard' element={<Dashboard />} />
          
          <Route path='/resturants' element={<ResturantList />} />
          <Route path='/resturants/create' element={<ResturantCreate />} />
          <Route path='/resturants/edit/:id' element={<EditResturant />} />

          <Route path='/categories' element={<CategoryList />} />
          <Route path='/categories/create' element={<CategoryCreate />} />
          <Route path='/categories/edit/:id' element={<CategoryEdit />} />

          <Route path='/foods' element={<FoodList />} />
          <Route path='/foods/create' element={<FoodCreate />} />
          <Route path='/foods/edit/:id' element={<FoodEdit />} />

          <Route path='/qr' element={<Qrcode />} />

          <Route path='/orders' element={<Order />} />
          <Route path='/orders/select' element={<OrderSelect />} />
          <Route path='/orders/all' element={<Orders />} />
          <Route path='/orders/analytics' element={<OrderAnalytics />} />
          <Route path='/order/:id' element={<OrderItem />} />

          <Route path='/offs' element={<OffCode />} />
          <Route path='/offs/create' element={<OffCodeCrate />} />
          <Route path='/offs/edit/:id' element={<OffCodeEdit />} />

          <Route path='/servers' element={<Server />} />
          <Route path='/servers/create_table' element={<CreateTable />} />
          <Route path='/servers/edit/:id' element={<EditTable />} />

          <Route path='/supports' element={<Support />} />
          <Route path='/supports/details/:id' element={<SupportDetails />} />

          <Route path='/users' element={<UserList />} />
          <Route path='/users/detail/:id' element={<UserDetail />} />

          <Route path='/files' element={<File />} />

          <Route path='/sliders' element={<Slider />} />
          <Route path='/sliders/create' element={<SliderCreate />} />
          <Route path='/sliders/edit/:id' element={<SliderEdit />} />

          <Route path='/setting' element={<Setting />} />

          <Route path='/customerClub' element={<CustomerClub />} />

          <Route path='/cc/users' element={<CCUserList />} />
          <Route path='/cc/users/create' element={<CCUserCreate />} />
          <Route path='/cc/users/detail/:id' element={<CCUserDetail />} />

          <Route path='/cc/comments' element={<CCCommentsList />} />
          <Route path='/cc/comments/detail/:id' element={<CCCommentsDetail />} />

          <Route path='/cc/campaigns' element={<CCCampaignsList />} />
          <Route path='/cc/campaigns/create' element={<CCCampaignsCreate />} />
          <Route path='/cc/campaigns/detail/:id' element={<CCCampaignsDetail />} />

          <Route path='/cc/orders' element={<CCOrder />} />

          <Route path='/cc/reports' element={<CCReport />} />

          <Route path='/cc/offs' element={<CCOffCodeList />} />
          <Route path='/cc/offs/create' element={<CCOffCodeCreate />} />
          <Route path='/cc/offs/detail/:id' element={<CCOffCodeDetail />} />

          <Route path='/cc/cashback' element={<CCCashBack />} />

          <Route path='/cc/sendSms' element={<CCSendSms />} />

          <Route path='/internalMenu' element={<InternalMenu />} />

          <Route path='/im/resturants' element={<IMResturantList />} />
          <Route path='/im/resturants/create' element={<IMResturantCreate />} />
          <Route path='/im/resturants/edit/:id' element={<IMEditResturant />} />

          <Route path='/im/categories' element={<IMCategoryList />} />
          <Route path='/im/categories/create' element={<IMCategoryCreate />} />
          <Route path='/im/categories/edit/:id' element={<IMCategoryEdit />} />

          <Route path='/im/foods' element={<IMFoodList />} />
          <Route path='/im/foods/create' element={<IMFoodCreate />} />
          <Route path='/im/foods/edit/:id' element={<IMFoodEdit />} />

          <Route path='/im/qr' element={<IMQrcode />} />

          <Route path='/im/files' element={<IMFiles />} />

          <Route path='/im/servers' element={<IMServer />} />
          <Route path='/im/servers/create_table' element={<IMCreateTable />} />
          <Route path='/im/servers/edit/:id' element={<IMEditTable />} />

          <Route path='/im/faq' element={<IMFaq />} />
          <Route path='/im/faq/create' element={<IMFaqCreate />} />
          <Route path='/im/faq/edit/:id' element={<IMFaqEdit />} />

          <Route path='/im/jobs' element={<IMJobs />} />
          <Route path='/im/jobs/detail/:id' element={<IMJobsDetails />} />

          <Route path='/im/reservation' element={<IMReservation />} />
          <Route path='/im/reservation/detail/:id' element={<IMReservationDetails />} />

          <Route path='/im/sliders' element={<IMSlider />} />
          <Route path='/im/sliders/create' element={<IMSliderCreate />} />
          <Route path='/im/sliders/edit/:id' element={<IMSliderEdit />} />

          <Route path='/im/banners' element={<IMBanner />} />
          <Route path='/im/banners/create' element={<IMBannerCreate />} />
          <Route path='/im/banners/edit/:id' element={<IMBannerEdit />} />

          <Route path='/peyk' element={<PeykDashbord />} />

          <Route path='/peyk/peyks' element={<PeyksList />} />
          <Route path='/peyk/peyks/create' element={<PeykCreate />} />
          <Route path='/peyk/peyks/edit/:id' element={<PeykEdit />} />

          <Route path='/peyk/orders' element={<PeykOrderList />} />
          <Route path='/peyk/orders/detail/:id' element={<PeykOrderDetail />} />

          <Route path='/peyk/accounting' element={<PeykAccounting />} />

          <Route path='/peyk/monitoring' element={<PeykMonitoring />} />

          <Route path='/peyk/messages' element={<PeykMessageList />} />
          <Route path='/peyk/messages/send' element={<PeykMessageSend />} />
          <Route path='/peyk/messages/detail/:id' element={<PeykMessageDetail />} />

          <Route path='/peyk/jobs' element={<PeykJobList />} />
          <Route path='/peyk/jobs/detail/:id' element={<PeykJobDetail />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App
